<template>
  <li
    :class="{ 'boss-period-end': !isPublished }"
    class="boss-scoutandlike-item"
  >
    <div class="boss-main-content-wrap">
      <h2
        :class="{ 'boss-contract': isPublished }"
        class="boss-joboffer-title"
      >
        求人ID:{{ job.id }} {{ job.managementName }}
      </h2>
      <div class="boss-scoutandlike-item-list">
        <scout-topic-recommendation
          :job-id="job.id"
          :contract-id="contractId"
          :is-published="isPublished"
        />
        <scout-topic-search-condition
          :job-id="job.id"
          :search-condition-id="searchConditionId"
          :contract-id="contractId"
        />
        <scout-topic-candidate
          :job-id="job.id"
          :contract-id="contractId"
          :count="candidatesCount"
        />
        <scout-topic-scouted
          :job-id="job.id"
          :contract-id="contractId"
          :scout-end-date="job.scoutEndDate"
          :count="scoutedCount"
        />
        <scout-topic-reservation
          :job-id="job.id"
          :contract-id="contractId"
          :reservation-count="reservationCount"
          :reservation-user-count="reservationUserCount"
        />
      </div>
    </div>
  </li>
</template>

<script>
import ScoutTopicSearchCondition from '@/components/molecules/ScoutTopicSearchCondition'
import ScoutTopicCandidate from '@/components/molecules/ScoutTopicCandidate'
import ScoutTopicRecommendation from '@/components/molecules/ScoutTopicRecommendation'
import ScoutTopicScouted from '@/components/molecules/ScoutTopicScouted'
import ScoutTopicReservation from '@/components/molecules/ScoutTopicReservation'

export default {
  components: {
    ScoutTopicSearchCondition,
    ScoutTopicCandidate,
    ScoutTopicRecommendation,
    ScoutTopicScouted,
    ScoutTopicReservation
  },
  props: {
    job: {
      type: Object,
      required: true
    },
    contractId: {
      type: Number,
      required: true
    },
    associatedUserCountWithJob: {
      type: Object,
      required: true
    }
  },
  computed: {
    isPublished () {
      return this.job.isPublished
    },
    searchConditionId () {
      return this.associatedUserCountWithJob.latestSearchConditionId
    },
    candidatesCount () {
      return this.associatedUserCountWithJob.candidatesCount
    },
    scoutedCount () {
      return this.associatedUserCountWithJob.scoutedCount
    },
    reservationCount () {
      return this.associatedUserCountWithJob.reservationCount
    },
    reservationUserCount () {
      return this.associatedUserCountWithJob.reservationUserCount
    }
  }
}

</script>
